import { ChatMessage, ChatOneToOneConversation } from "../data_models/chat";
import { IEmployer } from "../data_models/employer";
import { EUserType } from "../data_models/enums";
import { IFreelancer } from "../data_models/freelancer";
import { UserId } from "../data_models/helpers";
import { Invitation } from "../data_models/invitation";

// sort messages and invitations chronologically (using their _createdAt field) and return a sorted list
export function getSortedListOfMessages(messages: ChatMessage[]): ChatMessage[] {

    // Sort the combined list by the _createdAt field
    messages.sort((a, b) => {
        // Ensure _createdAt is a Date object
        const dateA = a._createdAt instanceof Date ? a._createdAt : new Date(a._createdAt!);
        const dateB = b._createdAt instanceof Date ? b._createdAt : new Date(b._createdAt!);

        // Compare the timestamps
        return dateA.getTime() - dateB.getTime(); // Ascending order (earliest to latest)
    });

    return messages;
}

// remove duplicates from messages
export function removeDuplicatesFromMessages(messages: ChatMessage[]): ChatMessage[] {
    const uniqueMessages = new Map();
    for (const message of messages) {
        if (!uniqueMessages.has(message._id)) {
            uniqueMessages.set(message._id, message);
        }
    }
    return Array.from(uniqueMessages.values()); // return an array of unique messages
}

export function getConverstationIdForInvitation(invitation: Invitation, conversations: ChatOneToOneConversation[]): string | undefined {
    for (const conversation of conversations) {
        for (const participant of conversation.participants) {
            if (participant.id === invitation.freelancerId && participant.userType === EUserType.FREELANCER) {
                return conversation._id; // Return the conversation ID directly
            }
        }
    }
    return undefined;
}

// sort conversations by lastMessageAt field. most recent first
export function getSortedConversations(conversations: ChatOneToOneConversation[]): ChatOneToOneConversation[] {
    return conversations?.sort((a, b) => {
        // Ensure lastMessageAt is a Date object
        const dateA = a.lastMessageAt instanceof Date ? a.lastMessageAt : new Date(a.lastMessageAt!);
        const dateB = b.lastMessageAt instanceof Date ? b.lastMessageAt : new Date(b.lastMessageAt!);

        // Sort in descending order (most recent first)
        return dateB.getTime() - dateA.getTime();
    });
}

export function getNumberUnreadMessagesInConversation(conversation: ChatOneToOneConversation, currentUserId: UserId): number {
    const currentUserIndex = conversation.participants.findIndex(participant => participant.id === currentUserId.id && participant.userType === currentUserId.userType);
    if (currentUserIndex === -1) {
        return 0;
    }

    return conversation.participantsNumberUnreadMessages.length > currentUserIndex
        ? conversation.participantsNumberUnreadMessages[currentUserIndex]
        : 0;
}